class Repartidor{
    constructor(id, nombre){
        this.id = id;
        this.nombre = nombre;
    }
}
export default Repartidor;
